import {
  Button,
  IconArrowInbox,
  IconCalendarDays,
  IconCheckmark,
  IconChainLink,
  Tooltip,
  BorderRadius8,
  GreyGrey20,
  GreyGrey70,
  Primary13SemiBold,
  Flex,
  Grid
} from '@sequencehq/core-components'
import { usePublishedStatus } from 'Cube/view/layouts/quote/QuoteEditorSidebar/usePublishedStatus'
import { StatusBadge } from './widgets/StatusBadge'

const styles = {
  button: {
    backgroundColor: GreyGrey20,
    height: '32px',
    alignItems: 'center',
    borderRadius: BorderRadius8,
    justifyContent: 'center',
    ...Primary13SemiBold
  },
  label: {
    ...Primary13SemiBold,
    color: GreyGrey70
  }
}

/**
 * @deprecated
 */
export const PublishedStatus = () => {
  const hook = usePublishedStatus()

  return (
    <Grid
      columnGap="8px"
      alignItems="center"
      templateColumns="1fr"
      gridAutoFlow="column"
      marginBottom="16px"
    >
      <StatusBadge status={hook.status} data-testid="quote.status" />
      {hook.features.copyLinkAction.visible && (
        <Tooltip
          label={hook.features.copyLinkAction.tooltip}
          placement="bottom"
        >
          <Flex
            as={Button}
            {...styles.button}
            width="32px"
            onClick={hook.features.copyLinkAction.onClick}
            onBlur={hook.features.copyLinkAction.onBlur}
          >
            {hook.features.copyLinkAction.isCopied ? (
              <IconCheckmark color={GreyGrey70} />
            ) : (
              <IconChainLink color={GreyGrey70} />
            )}
          </Flex>
        </Tooltip>
      )}
      {hook.features.download.visible && (
        <Tooltip label={hook.features.download.tooltip} placement="bottom">
          <Flex
            as={Button}
            {...styles.button}
            width="32px"
            onClick={hook.features.download.onClick}
            disabled={hook.features.download.disabled}
          >
            <IconArrowInbox color={GreyGrey70} />
          </Flex>
        </Tooltip>
      )}
      {hook.features.openBillingSchedule.visible && (
        <Tooltip
          label={hook.features.openBillingSchedule.tooltip}
          placement="bottom"
        >
          <Flex
            as={Button}
            {...styles.button}
            width="32px"
            onClick={hook.features.openBillingSchedule.onClick}
          >
            <IconCalendarDays color={GreyGrey70} />
          </Flex>
        </Tooltip>
      )}
    </Grid>
  )
}
